import React from 'react';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error('[ErrorBoundary] Uncaught error:', error, info.componentStack);
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#fafafa',
        gap: 24,
        padding: 32,
        textAlign: 'center',
      }}>
        <img src="/logo-charth.png" alt="Charth" style={{ height: 40, opacity: 0.6 }} />
        <div style={{ fontSize: 48 }}>⚠️</div>
        <div>
          <h2 style={{ color: 'var(--pantone)', margin: '0 0 8px', fontSize: 20 }}>
            Algo deu errado
          </h2>
          <p style={{ color: '#666', margin: '0 0 24px', fontSize: 14, maxWidth: 400 }}>
            Ocorreu um erro inesperado. Recarregue a página para continuar.
          </p>
          {this.state.error && (
            <details style={{ textAlign: 'left', background: '#fff3f3', border: '1px solid #fcc', borderRadius: 8, padding: 12, maxWidth: 500, marginBottom: 24 }}>
              <summary style={{ cursor: 'pointer', fontSize: 12, color: '#c00', fontFamily: 'monospace' }}>
                Detalhes do erro
              </summary>
              <pre style={{ fontSize: 11, marginTop: 8, whiteSpace: 'pre-wrap', color: '#900' }}>
                {this.state.error.toString()}
              </pre>
            </details>
          )}
          <button
            onClick={() => window.location.reload()}
            style={{
              background: 'var(--pantone)',
              color: '#fff',
              border: 'none',
              borderRadius: 8,
              padding: '10px 24px',
              fontSize: 14,
              cursor: 'pointer',
              fontWeight: 600,
            }}
          >
            🔄 Recarregar página
          </button>
        </div>
      </div>
    );
  }
}
